import React from "react";
import "../App.css";

const Resume = () => {
  return (
    <div className="resume-container">
      {/* HEADER */}
      {/* <h1 className="resume-title">Savannah C. Victoria — Résumé</h1> */}
      {/* ACTION BUTTONS */}
      <header className="resume-header">
        <h1 className="resume-title">Savannah Chanel Victoria</h1>
        <p className="resume-subtitle">
          Web Developer • Audio Engineer • Technical Director
        </p>
        <p className="resume-meta">
          Chicago, IL •{" "}
          <a href="mailto:savannah@svx.studio">savannah@svx.studio</a> •{" "}
          <a href="https://savannahchanel.me" target="_blank" rel="noreferrer">
            savannahchanel.me
          </a>
        </p>
      </header>
      {/* SUMMARY */}
      <section className="resume-section">
        <h2>Professional Summary</h2>
        <p>
          Versatile Technical Director, Audio Engineer, and Full-Stack Web
          Developer with 5+ years of production experience and growing expertise
          in front-end and back-end development. B.S. in Web Development &
          Design, passionate about merging storytelling, technology, and design
          to create engaging digital and media experiences.
        </p>
      </section>
      {/* SKILLS */}
      <section className="resume-section">
        <h2>Skills</h2>
        <ul className="resume-list">
          <li>
            <strong>Audio:</strong> Pro Tools, Dante, SMAART, Blackmagic Design,
            Shure WWB, Waves, Q-SYS, AV systems, live sound integration,
            hardware setup & training
          </li>
          <li>
            <strong>Web & Development:</strong> HTML, CSS, JavaScript (ES6+),
            TypeScript, JSX, Vite, React, React Native, Expo, Node.js, Express,
            Neovim, Firebase, OAuth, Git/GitHub, MySQL, MongoDB, AWS, Docker
          </li>
          <li>
            <strong>Design & UX:</strong> Figma, wireframing, prototyping, style
            tiles, responsive design, UI/UX collaboration
          </li>
          <li>
            <strong>Soft Skills:</strong> Creative problem-solving, analytical
            thinking, collaborative teamwork, live production leadership,
            technical troubleshooting
          </li>
          <li>
            <strong>Languages:</strong> English & Spanish — bilingual
            professional
          </li>
        </ul>
      </section>
      {/* EXPERIENCE */}
      <section className="resume-section">
        <h2>Experience</h2>

        <div className="job">
          <h3>Technical Director</h3>
          <h4>Wheaton Bible Church</h4>
          <p className="job-date">2019 – Present</p>
          <ul>
            <li>
              Lead weekly production; program consoles, build mic plots, and
              maintain AV systems.
            </li>
            <li>
              Train volunteers and troubleshoot live issues during services.
            </li>
          </ul>
        </div>
        <div className="job">
          <h3>Contract Technical Director</h3>
          <h4> Wheaton Academy, Wheaton</h4>
          <p className="job-date">2022 – Present</p>
          <ul>
            <li>
              Oversee student production teams and deliver hands-on support for
              live production operations for student theater performances with
              20+ actors and 20+ wireless microphones
            </li>
          </ul>
        </div>

        <div className="job">
          <h3>Freelance Audio Engineer</h3>
          <h4>Chicago, IL + Remote</h4>
          <p className="job-date">2021 – Present</p>
          <ul>
            <li>
              Sound recordist for film/video: location sound, lav/boom capture,
              and on-set troubleshooting.
            </li>
            <li>
              FOH/live sound support for venues and events: setup, patching,
              mixing, and system optimization.
            </li>
            <li>
              Post-production Foley for select projects with VRG Studios (IMDb
              credited).
            </li>
          </ul>
          <a href="https://www.imdb.com/name/nm11401704/?ref_=nmbio_ov_bk">
            IMDb Profile
          </a>
        </div>
        <div className="job">
          <h3>Web Developer — Freelance</h3>
          <h4>Chicago, IL + Remote</h4>
          <p className="job-date">2025 – Present</p>
          <ul>
            <li>
              Build and deploy responsive websites and web apps using React,
              Node/Express, and modern tooling; collaborate with clients to
              translate goals into clean UI, accessible layouts, and reliable
              functionality.
            </li>
          </ul>
        </div>
      </section>
      {/* EDUCATION */}
      <section className="resume-section">
        <h2>Education</h2>
        <p>
          <strong>B.S. Web Development & Design</strong> — Full Sail University
        </p>
        <p className="job-date">Graduated: November 2025</p>
        {/* <ul>
          <li>Graduated: November 2025</li>
        </ul> */}
        <p>
          <strong>A.A.S. Recording Arts</strong> — Flashpoint Chicago | A Campus
          of Columbia College Hollywood
        </p>
        <p className="job-date">Graduated: 2020</p>
        {/* <ul>
          <li> Graduated: 2020</li>
        </ul> */}
      </section>
      {/* <section className="resume-section">
        <h2>Certifications</h2>
        <ul className="resume-list">
          <li>Dante Level 1, 2 & 3</li>
          <li>AV Networking Essentials</li>
        </ul>
      </section> */}
      {/* CONTACT */}
      {/* <section className="resume-section contact">
        <h2>Contact</h2>
        <p>📧 savannah@svx.studio</p>
        <p>🌐 savannahchanel.me</p>
      </section> */}
    </div>
  );
};

export default Resume;
